<div class="row mb-3">
    <div class="col-md-6 d-flex align-items-center justify-content-md-end mb-1 mb-md-0 text-end">{{fieldTitle}}</div>
    <div class="col-md-6 form-group">
        <input *ngIf="(fieldType === 'input')" type="text" name="FieldValue" #FieldValue="ngModel" [(ngModel)]="fdata.FieldValue" class="form-control"/>
        <select *ngIf="(fieldType === 'select')" name="FieldValue" #FieldValue="ngModel" [(ngModel)]="fdata.FieldValue" class="form-select form-control">
            <option value="">-</option>
            <option *ngFor="let l of lists" value="{{l.ItemValue}}">{{l.ItemLabel}}</option>
        </select>
    </div>
</div>